export function createEstado() {
  return {
    Clave: '',
    EmpresaId: 0,
    PaisClave: '',
    Nombre: '',
    ClaveErp: '',
    Clave2: ''
  };
}
